module.exports = __webpack_public_path__ + "static/media/f2_converted.0458cdee.mp4";